/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ASCO';
  constructor(private authServ: AuthService) {
    this.authServ.handleAuthState()
  }
}